import sanityClient from "@sanity/client";

export const client = sanityClient({
  projectId: process.env.REACT_APP_SANITY_PROJECT_ID,
  dataset: process.env.REACT_APP_SANITY_DATASET || "production",
  useCdn: true,
  token: process.env.REACT_APP_SANITY_API_TOKEN,
  apiVersion: "2021-10-21",
});
